import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import Unauthorized from "../general/Unauthorized";
import SelectorProfesionalAsignado from "../custom/SelectorProfesionalAsignado";
// import * as XLSX from 'xlsx'; // Comentado temporalmente

function ReportePacientes() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pacientes, setPacientes] = useState([]);

    // Estados para filtros
    const [filtroNombre, setFiltroNombre] = useState('');
    const [filtroDocumento, setFiltroDocumento] = useState('');
    const [filtroSexo, setFiltroSexo] = useState('');
    const [filtroFechaNacimientoDesde, setFiltroFechaNacimientoDesde] = useState('');
    const [filtroFechaNacimientoHasta, setFiltroFechaNacimientoHasta] = useState('');
    const [filtroMesNacimiento, setFiltroMesNacimiento] = useState('');
    const [filtroFechaIngresoDesde, setFiltroFechaIngresoDesde] = useState('');
    const [filtroFechaIngresoHasta, setFiltroFechaIngresoHasta] = useState('');
    const [filtroProfesional, setFiltroProfesional] = useState('');

    const [paginaActual, setPaginaActual] = useState(1);
    const [registrosPorPagina, setRegistrosPorPagina] = useState(10);

    let userdata = [];

    const tamanoPagina = registrosPorPagina === 'all'
        ? Math.max(pacientes.length, 1)
        : Number(registrosPorPagina);

    const totalPaginas = registrosPorPagina === 'all'
        ? 1
        : Math.max(1, Math.ceil(pacientes.length / tamanoPagina));

    const pacientesPaginados = useMemo(() => {
        if (registrosPorPagina === 'all') {
            return pacientes;
        }
        const inicio = (paginaActual - 1) * registrosPorPagina;
        return pacientes.slice(inicio, inicio + registrosPorPagina);
    }, [pacientes, paginaActual, registrosPorPagina]);

    const indicePrimerRegistro = registrosPorPagina === 'all'
        ? 0
        : (paginaActual - 1) * registrosPorPagina;

    const indiceUltimoRegistro = registrosPorPagina === 'all'
        ? pacientes.length
        : Math.min(paginaActual * registrosPorPagina, pacientes.length);

    const cambiarPagina = (numeroPagina) => {
        if (numeroPagina < 1 || numeroPagina > totalPaginas) return;
        setPaginaActual(numeroPagina);
    };

    const getPaginationItems = (current, total) => {
        if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
        if (current <= 4) return [1, 2, 3, 4, '...', total];
        if (current >= total - 3) return [1, '...', total - 3, total - 2, total - 1, total];
        return [1, '...', current - 1, current, current + 1, '...', total];
    };

    useEffect(() => {
        setPaginaActual(1);
    }, [pacientes]);

    useEffect(() => {
        if (paginaActual > totalPaginas) {
            setPaginaActual(totalPaginas);
        }
    }, [paginaActual, totalPaginas]);

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        userdata = JSON.parse(localStorage.getItem('userdata'));

        // 🔒 VALIDACIÓN DE PERMISOS - Patrón híbrido (nuevo + legacy)
        let tienePermiso = false;
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'verReportePacientes');
        } else if (userdata.up && userdata.up.includes('verReportePacientes')) {
            tienePermiso = true;
        }

        if (!tienePermiso) {
            setHasPermission(false);
            setLoggedIn(true);
            return;
        }

        setHasPermission(true);

        // ✅ Sin config manual - el interceptor agrega el token automáticamente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                    cargarPacientes();
                }
            })
            .catch(error => {
                console.log(error);
                setLoggedIn(true);
            });
    }, []);

    const cargarPacientes = () => {
        if (!localStorage.getItem('userdata')) {
            return;
        }

        userdata = JSON.parse(localStorage.getItem('userdata'));
        setLoading(true);

        // ✅ Patrón de parámetros siguiendo el estándar del proyecto
        const params = {
            uid: userdata.user_id, // ✅ Parámetro uid requerido
            solo_pacientes: true, // ✅ Excluir empresas (tipo_cliente = 1)
            nombre: filtroNombre,
            documento: filtroDocumento,
            sexo: filtroSexo,
            fecha_nacimiento_desde: filtroFechaNacimientoDesde,
            fecha_nacimiento_hasta: filtroFechaNacimientoHasta,
            mes_nacimiento: filtroMesNacimiento,
            fecha_ingreso_desde: filtroFechaIngresoDesde,
            fecha_ingreso_hasta: filtroFechaIngresoHasta,
            profesional: filtroProfesional
        };

        // ✅ Sin config manual - el interceptor agrega el token automáticamente
        axios.get('/reporte-pacientes', { params })
            .then(response => {
                if (response.status === 200) {
                    setPacientes(response.data);
                }
                setLoading(false);
            })
            .catch(error => {
                console.log(error);
                setLoading(false);
            });
    };

    const handleBuscar = () => {
        cargarPacientes();
    };

    const handleLimpiarFiltros = () => {
        setFiltroNombre('');
        setFiltroDocumento('');
        setFiltroSexo('');
        setFiltroFechaNacimientoDesde('');
        setFiltroFechaNacimientoHasta('');
        setFiltroMesNacimiento('');
        setFiltroFechaIngresoDesde('');
        setFiltroFechaIngresoHasta('');
        setFiltroProfesional('');
        // Recargar sin filtros
        setTimeout(() => {
            cargarPacientes();
        }, 100);
    };

    const exportarExcel = () => {
        if (pacientes.length === 0) {
            alert('No hay datos para exportar');
            return;
        }

        try {
            // Importación dinámica de XLSX para evitar problemas de resolución
            import('xlsx').then(XLSX => {
                // Preparar datos para Excel
                const datosExcel = pacientes.map(paciente => ({
                    'Primer Nombre': paciente.primer_nombre || '',
                    'Segundo Nombre': paciente.segundo_nombre || '',
                    'Primer Apellido': paciente.primer_apellido || '',
                    'Segundo Apellido': paciente.segundo_apellido || '',
                    'Nombre Completo': paciente.nombre_completo || '',
                    'Tipo Documento': paciente.tipo_documento || '',
                    'Número Documento': paciente.numero_documento || '',
                    'Sexo': paciente.sexo === '01' ? 'Masculino' : paciente.sexo === '02' ? 'Femenino' : paciente.sexo || '',
                    'Fecha Nacimiento': paciente.fecha_nacimiento || '',
                    'País Nacimiento': paciente.nombre_pais_nacimiento || '',
                    'Fecha Ingreso': paciente.fechaingreso ? paciente.fechaingreso.split('T')[0] : '',
                    'RH': paciente.rh || '',
                    'Estado Civil': paciente.estado_civil || '',
                    'Teléfono': paciente.telefono || '',
                    'Celular': paciente.celular || '',
                    'Email': paciente.email || '',
                    'Dirección': paciente.direccion || '',
                    'Ciudad': paciente.ciudad_nombre || '',
                    'País Residencia': paciente.nombre_pais_residencia || '',
                    'Profesional Asignado': paciente.profesional_nombre || '',
                    'EPS': paciente.eps_nombre || '',
                    'Estado': paciente.estado === 1 ? 'Activo' : 'Inactivo'
                }));

                // Crear libro de Excel
                const ws = XLSX.utils.json_to_sheet(datosExcel);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Pacientes");

                // Generar nombre de archivo con fecha
                const fecha = new Date().toISOString().split('T')[0];
                const nombreArchivo = `reporte_pacientes_${fecha}.xlsx`;

                // Descargar archivo
                XLSX.writeFile(wb, nombreArchivo);
            }).catch(error => {
                console.error('Error cargando XLSX:', error);
                // Fallback a CSV si XLSX no está disponible
                exportarCSV();
            });
        } catch (error) {
            console.error('Error en exportación:', error);
            // Fallback a CSV si hay cualquier error
            exportarCSV();
        }
    };

    const exportarCSV = () => {
        // Preparar datos para CSV
        const headers = [
            'Primer Nombre', 'Segundo Nombre', 'Primer Apellido', 'Segundo Apellido',
            'Nombre Completo', 'Tipo Documento', 'Número Documento', 'Sexo', 'Fecha Nacimiento',
            'País Nacimiento', 'Fecha Ingreso', 'RH', 'Estado Civil', 'Teléfono', 'Celular', 'Email', 'Dirección', 'Ciudad',
            'País Residencia', 'Profesional Asignado', 'EPS', 'Estado'
        ];

        const csvContent = [
            headers.join(','),
            ...pacientes.map(paciente => [
                paciente.primer_nombre || '',
                paciente.segundo_nombre || '',
                paciente.primer_apellido || '',
                paciente.segundo_apellido || '',
                paciente.nombre_completo || '',
                paciente.tipo_documento || '',
                paciente.numero_documento || '',
                paciente.sexo === '01' ? 'Masculino' : paciente.sexo === '02' ? 'Femenino' : paciente.sexo || '',
                paciente.fecha_nacimiento || '',
                paciente.nombre_pais_nacimiento || '',
                paciente.fechaingreso ? paciente.fechaingreso.split('T')[0] : '',
                paciente.rh || '',
                paciente.estado_civil || '',
                paciente.telefono || '',
                paciente.celular || '',
                paciente.email || '',
                paciente.direccion || '',
                paciente.ciudad_nombre || '',
                paciente.nombre_pais_residencia || '',
                paciente.profesional_nombre || '',
                paciente.eps_nombre || '',
                paciente.estado === 1 ? 'Activo' : 'Inactivo'
            ].map(field => `"${field}"`).join(','))
        ].join('\n');

        // Crear y descargar archivo CSV
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        const fecha = new Date().toISOString().split('T')[0];
        link.setAttribute('download', `reporte_pacientes_${fecha}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        alert('Archivo exportado como CSV (Excel no disponible)');
    };

    // 🔒 PROTECCIÓN DE RUTA - Patrón estándar del proyecto
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn) {
        return <Loading />;
    }
    return (
        <div className="hold-transition">
            <Header client={client} />
            <Aside client={client} activelink="reports" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/estadisticas">Reportes</Link></li>
                                    <li className="breadcrumb-item">Reporte de Pacientes</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <h1 className="m-0">Reporte de Pacientes</h1>
                            </div>
                        </div>
                    </div>
                </div>

                    <section className="content">
                        <div className="container-fluid">

                            {/* FILTROS */}
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Filtros de Búsqueda</h3>
                                </div>
                                <div className="card-body">
                                    {/* Primera fila - Filtros básicos */}
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="filtroNombre">Nombre del Paciente</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="filtroNombre"
                                                    placeholder="Buscar por nombre..."
                                                    value={filtroNombre}
                                                    onChange={(e) => setFiltroNombre(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label htmlFor="filtroDocumento">Número de Documento</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="filtroDocumento"
                                                    placeholder="Número de documento..."
                                                    value={filtroDocumento}
                                                    onChange={(e) => setFiltroDocumento(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label htmlFor="filtroSexo">Sexo</label>
                                                <select
                                                    className="form-control"
                                                    id="filtroSexo"
                                                    value={filtroSexo}
                                                    onChange={(e) => setFiltroSexo(e.target.value)}
                                                >
                                                    <option value="">Todos</option>
                                                    <option value="01">Masculino</option>
                                                    <option value="02">Femenino</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="filtroProfesional">Profesional Asignado</label>
                                                <SelectorProfesionalAsignado
                                                    value={filtroProfesional}
                                                    onChange={setFiltroProfesional}
                                                    showLabel={false}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Segunda fila - Filtros de fechas agrupados */}
                                    <div className="row">
                                        {/* Grupo: Fecha de Nacimiento */}
                                        <div className="col-md-5">
                                            <fieldset className="border p-2">
                                                <legend className="w-auto px-2" style={{ fontSize: '0.9rem', marginBottom: '0.5rem' }}>Fecha de Nacimiento</legend>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group mb-2">
                                                            <label htmlFor="filtroMesNacimiento" style={{ fontSize: '0.85rem' }}>Mes</label>
                                                            <select
                                                                className="form-control form-control-sm"
                                                                id="filtroMesNacimiento"
                                                                value={filtroMesNacimiento}
                                                                onChange={(e) => {
                                                                    setFiltroMesNacimiento(e.target.value);
                                                                    if (e.target.value) {
                                                                        setFiltroFechaNacimientoDesde('');
                                                                        setFiltroFechaNacimientoHasta('');
                                                                    }
                                                                }}
                                                            >
                                                                <option value="">Todos</option>
                                                                <option value="1">Enero</option>
                                                                <option value="2">Febrero</option>
                                                                <option value="3">Marzo</option>
                                                                <option value="4">Abril</option>
                                                                <option value="5">Mayo</option>
                                                                <option value="6">Junio</option>
                                                                <option value="7">Julio</option>
                                                                <option value="8">Agosto</option>
                                                                <option value="9">Septiembre</option>
                                                                <option value="10">Octubre</option>
                                                                <option value="11">Noviembre</option>
                                                                <option value="12">Diciembre</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group mb-2">
                                                            <label htmlFor="filtroFechaNacimientoDesde" style={{ fontSize: '0.85rem' }}>Desde</label>
                                                            <input
                                                                type="date"
                                                                className="form-control form-control-sm"
                                                                id="filtroFechaNacimientoDesde"
                                                                value={filtroFechaNacimientoDesde}
                                                                disabled={filtroMesNacimiento !== ''}
                                                                onChange={(e) => {
                                                                    setFiltroFechaNacimientoDesde(e.target.value);
                                                                    if (e.target.value) {
                                                                        setFiltroMesNacimiento('');
                                                                    }
                                                                }}
                                                            />
                                                            {filtroMesNacimiento && (
                                                                <small className="text-muted" style={{ fontSize: '0.75rem' }}>Deshabilitado</small>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group mb-2">
                                                            <label htmlFor="filtroFechaNacimientoHasta" style={{ fontSize: '0.85rem' }}>Hasta</label>
                                                            <input
                                                                type="date"
                                                                className="form-control form-control-sm"
                                                                id="filtroFechaNacimientoHasta"
                                                                value={filtroFechaNacimientoHasta}
                                                                disabled={filtroMesNacimiento !== ''}
                                                                onChange={(e) => {
                                                                    setFiltroFechaNacimientoHasta(e.target.value);
                                                                    if (e.target.value) {
                                                                        setFiltroMesNacimiento('');
                                                                    }
                                                                }}
                                                            />
                                                            {filtroMesNacimiento && (
                                                                <small className="text-muted" style={{ fontSize: '0.75rem' }}>Deshabilitado</small>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>

                                        {/* Grupo: Fecha de Ingreso */}
                                        <div className="col-md-4">
                                            <fieldset className="border p-2">
                                                <legend className="w-auto px-2" style={{ fontSize: '0.9rem', marginBottom: '0.5rem' }}>Fecha de Ingreso</legend>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-2">
                                                            <label htmlFor="filtroFechaIngresoDesde" style={{ fontSize: '0.85rem' }}>Desde</label>
                                                            <input
                                                                type="date"
                                                                className="form-control form-control-sm"
                                                                id="filtroFechaIngresoDesde"
                                                                value={filtroFechaIngresoDesde}
                                                                onChange={(e) => setFiltroFechaIngresoDesde(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-2">
                                                            <label htmlFor="filtroFechaIngresoHasta" style={{ fontSize: '0.85rem' }}>Hasta</label>
                                                            <input
                                                                type="date"
                                                                className="form-control form-control-sm"
                                                                id="filtroFechaIngresoHasta"
                                                                value={filtroFechaIngresoHasta}
                                                                onChange={(e) => setFiltroFechaIngresoHasta(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <button
                                                type="button"
                                                className="btn btn-primary mr-2"
                                                onClick={handleBuscar}
                                                disabled={loading}
                                            >
                                                <i className="fas fa-search"></i> Buscar
                                                {loading && <span className="spinner-border spinner-border-sm ml-2"></span>}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary mr-2"
                                                onClick={handleLimpiarFiltros}
                                            >
                                                <i className="fas fa-eraser"></i> Limpiar Filtros
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-success"
                                                onClick={exportarExcel}
                                                disabled={pacientes.length === 0}
                                                title="Exportar datos a Excel (o CSV si Excel no está disponible)"
                                            >
                                                <i className="fas fa-file-excel"></i> Exportar Datos
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* TABLA DE RESULTADOS */}
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">
                                        Resultados ({pacientes.length} pacientes encontrados)
                                    </h3>
                                </div>
                                <div className="card-body">
                                    {loading ? (
                                        <div className="text-center">
                                            <div className="spinner-border" role="status">
                                                <span className="sr-only">Cargando...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="table-responsive" style={{ overflowX: 'auto' }}>
                                            <table className="table table-bordered table-striped" style={{ minWidth: '1200px' }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ minWidth: '200px', textAlign: 'center' }}>Nombre Completo</th>
                                                        <th style={{ minWidth: '80px', textAlign: 'center' }}>Tipo</th>
                                                        <th style={{ minWidth: '120px', textAlign: 'center' }}>N° Documento</th>
                                                        <th style={{ minWidth: '80px', textAlign: 'center' }}>Sexo</th>
                                                        <th style={{ minWidth: '130px', textAlign: 'center' }}>Fecha Nacimiento</th>
                                                        <th style={{ minWidth: '100px', textAlign: 'center' }}>Teléfono</th>
                                                        <th style={{ minWidth: '100px', textAlign: 'center' }}>Celular</th>
                                                        <th style={{ minWidth: '200px', textAlign: 'center' }}>Email</th>
                                                        <th style={{ minWidth: '150px', textAlign: 'center' }}>Ciudad</th>
                                                        <th style={{ minWidth: '180px', textAlign: 'center' }}>Profesional Asignado</th>
                                                        <th style={{ minWidth: '80px', textAlign: 'center' }}>Estado</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {pacientesPaginados.length > 0 ? (
                                                        pacientesPaginados.map((paciente) => (
                                                            <tr key={paciente.id || `${paciente.numero_documento}-${paciente.nombre_completo}`}>
                                                                <td style={{ minWidth: '200px', wordWrap: 'break-word' }}>{paciente.nombre_completo || '-'}</td>
                                                                <td style={{ minWidth: '80px' }}>{paciente.tipo_documento || '-'}</td>
                                                                <td style={{ minWidth: '120px' }}>{paciente.numero_documento || '-'}</td>
                                                                <td style={{ minWidth: '80px' }}>{paciente.sexo === '01' ? 'Masculino' : paciente.sexo === '02' ? 'Femenino' : paciente.sexo || '-'}</td>
                                                                <td style={{ minWidth: '130px' }}>{paciente.fecha_nacimiento || '-'}</td>
                                                                <td style={{ minWidth: '100px' }}>{paciente.telefono || '-'}</td>
                                                                <td style={{ minWidth: '100px' }}>{paciente.celular || '-'}</td>
                                                                <td style={{ minWidth: '200px', wordWrap: 'break-word' }}>{paciente.email || '-'}</td>
                                                                <td style={{ minWidth: '150px', wordWrap: 'break-word' }}>{paciente.ciudad_nombre || '-'}</td>
                                                                <td style={{ minWidth: '180px', wordWrap: 'break-word' }}>{paciente.profesional_nombre || '-'}</td>
                                                                <td style={{ minWidth: '80px' }}>
                                                                    <span className={`badge ${paciente.estado === 1 ? 'badge-success' : 'badge-secondary'}`}>
                                                                        {paciente.estado === 1 ? 'Activo' : 'Inactivo'}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="11" className="text-center">
                                                                No se encontraron pacientes con los filtros aplicados
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}

                                    {!loading && pacientes.length > 0 && (
                                        <div className="d-flex justify-content-between align-items-center flex-wrap px-2 py-3" style={{ gap: '12px', borderTop: '1px solid #eef2f6' }}>
                                            <div className="d-flex align-items-center flex-wrap" style={{ gap: '10px' }}>
                                                <span className="text-muted" style={{ fontSize: '0.86rem' }}>
                                                    Mostrando <strong>{indicePrimerRegistro + 1}</strong> a <strong>{indiceUltimoRegistro}</strong> de <strong>{pacientes.length}</strong> pacientes
                                                </span>
                                                <label className="mb-0 d-flex align-items-center text-muted" style={{ fontSize: '0.86rem', gap: '6px' }}>
                                                    Filas por página:
                                                    <select
                                                        className="form-control form-control-sm"
                                                        style={{ width: 'auto', minWidth: '88px' }}
                                                        value={registrosPorPagina}
                                                        onChange={(e) => {
                                                            const valor = e.target.value === 'all' ? 'all' : Number(e.target.value);
                                                            setRegistrosPorPagina(valor);
                                                            setPaginaActual(1);
                                                        }}
                                                    >
                                                        <option value={10}>10</option>
                                                        <option value={50}>50</option>
                                                        <option value={100}>100</option>
                                                        <option value="all">Todos</option>
                                                    </select>
                                                </label>
                                            </div>

                                            {registrosPorPagina !== 'all' && totalPaginas > 1 && (
                                                <nav>
                                                    <ul className="pagination pagination-sm mb-0" style={{ gap: '5px' }}>
                                                        <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                                                            <button
                                                                type="button"
                                                                className="page-link border-0 shadow-sm"
                                                                onClick={() => cambiarPagina(paginaActual - 1)}
                                                                style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#323a45' }}
                                                            >
                                                                ‹
                                                            </button>
                                                        </li>
                                                        {getPaginationItems(paginaActual, totalPaginas).map((item, idx) => {
                                                            if (item === '...') {
                                                                return (
                                                                    <li key={`ellipsis-${idx}`} className="page-item disabled">
                                                                        <span className="page-link border-0 bg-transparent">...</span>
                                                                    </li>
                                                                );
                                                            }
                                                            return (
                                                                <li key={item} className={`page-item ${paginaActual === item ? 'active' : ''}`}>
                                                                    <button
                                                                        type="button"
                                                                        className="page-link border-0 shadow-sm"
                                                                        onClick={() => cambiarPagina(item)}
                                                                        style={{
                                                                            borderRadius: '8px',
                                                                            padding: '6px 12px',
                                                                            background: paginaActual === item ? '#17a2b8' : '#f8f9fa',
                                                                            color: paginaActual === item ? 'white' : '#323a45',
                                                                            fontWeight: paginaActual === item ? '600' : '500'
                                                                        }}
                                                                    >
                                                                        {item}
                                                                    </button>
                                                                </li>
                                                            );
                                                        })}
                                                        <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
                                                            <button
                                                                type="button"
                                                                className="page-link border-0 shadow-sm"
                                                                onClick={() => cambiarPagina(paginaActual + 1)}
                                                                style={{ borderRadius: '8px', padding: '6px 12px', background: '#f8f9fa', color: '#323a45' }}
                                                            >
                                                                ›
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>
                    </section>
                </div>
            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default ReportePacientes;